import React, { useEffect, useRef, useState } from "react"
import {
  Table,
  Input,
  Select,
  Modal,
  Form,
  Radio,
  Card,
  Typography,
  Image,
  Row,
  Col,
  Pagination,
  Spin,
  Skeleton,
  message,
  Empty,
  Descriptions,
  Drawer,
  InputNumber,
  Badge,
  Divider,
} from "antd"
import {
  FireFilled,
  FrownOutlined,
  ShareAltOutlined,
  ShoppingCartOutlined,
} from "@ant-design/icons"
import Button from "../../../components/MyButton/Button"
import PublicService from "src/services/PublicService"
import STORAGE, { getStorage, getStorageCookie } from "src/lib/storage"
import { set } from "lodash"
import ModalAuth from "src/components/Layouts/component/ModalAuth"
import { useLocation, useNavigate } from "react-router-dom"
import { simType } from "src/constants/constants"
import { useDispatch, useSelector } from "react-redux"
import {
  addToCart,
  updateCartItemQuantity,
  removeFromCart,
  clearCart,
} from "src/redux/cartSlice"
import OrderB2BService from "src/services/OrderB2BService"
import ROUTER from "src/router"
import ModalDeposite from "src/pages/LEADER/BuySimPackage/Modal/ModalDeposite"
import BuyPackageAnonymous from "src/pages/ANONYMOUS/BuyPackage"
import { InputSearchStyle } from "src/pages/ADMIN/HumanResource/styled"
import SvgIcon from "src/components/SvgIcon"

const { Search } = Input
const { Option } = Select
const { Title, Text } = Typography
const phoneRegex = /^0\d{9}$/
const serviceTypeMap = {
  1: "Local",
  2: "Roaming",
}

const PackagePurchase = props => {
  const [searchValue, setSearchValue] = useState("")
  const [data, setData] = useState([])
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 6,
  })
  const [keyword, setKeyword] = useState("")
  const [selectedPackage, setSelectedPackage] = useState(null)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isPhoneModalVisible, setIsPhoneModalVisible] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState("")
  const [filter, setFilter] = useState({})
  const [loading, setLoading] = useState(true)
  const [modalLoginOpen, setModalLoginOpen] = useState(false)
  const [drawerVisible, setDrawerVisible] = useState(false)
  const [bulkQuantity, setBulkQuantity] = useState(1) // Số lượng mặc định là 1
  const [arrearsMoney, setArrearsMoney] = useState(0)
  const [depositVisible, setDepositVisible] = useState(false)
  const [networkData, setNetworkData] = useState("")

  const role = localStorage.getItem(STORAGE.ROLES)
  const isLogin = getStorageCookie(STORAGE.TOKEN)

  const cartItems = useSelector(state => state.cart.items)
  const dispatch = useDispatch()

  const navigate = useNavigate()

  const location = useLocation()
  const selectedPackageNav = location.state || {}
  console.log(keyword, "keyword")
  const level = localStorage.getItem(STORAGE.LEVEL)
  const inputSearchRef = useRef()
  const onSearch = () => {
    const keyword = inputSearchRef.current.trim() || ""
    setKeyword(keyword)
  }
  const onClearSearch = () => {
    inputSearchRef.current = ""
    setKeyword("")
  }
  // const debouncedSetFilter = useMemo(
  //   () =>
  //     debounce(value => {
  //       setFilter(prev => ({ ...prev, full_name: value }))
  //     }, 1000),
  //   [setFilter],
  // )
  const showDrawer = () => {
    setDrawerVisible(true)
  }

  const onClose = () => {
    setDrawerVisible(false)
  }
  console.log(cartItems, "cartItems in cart drawer")

  const fetchListPackage = async () => {
    setLoading(true)
    if (!keyword) {
      setLoading(false)
      return
    }

    try {
      const response = await OrderB2BService.searchBuyData({
        BillingCode: keyword,
      })

      const success = response?.success?.original?.data
      if (success) {
        const packages = success.Packs || []
        setNetworkData(success.ProductCode || "")
        setData(packages)
      } else {
        console.error("Failed to fetch packages:", response?.error)
      }
    } catch (error) {
      console.error("Error fetching packages:", error)
      message.error("Đã xảy ra lỗi khi tìm kiếm gói cước.")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchListPackage()
  }, [keyword])
  // useEffect(() => {
  //   if (pagination.current !== 1) {
  //     setPagination(prev => ({
  //       ...prev,
  //       current: 1,
  //     }))
  //   } else {
  //     if (pagination.total !== undefined && !isLogin) {
  //       fetchListPackage(keyword)
  //     }
  //   }
  // }, [keyword, filter])

  const handleCardClick = packageItem => {
    if (!isLogin) {
      message.error("Vui lòng đăng nhập")
      // return navigate(ROUTER.DANG_NHAP, { state: { from: "order", record } })
      setModalLoginOpen(true)
      return
    }
    console.log(packageItem)
    // setIsPhoneModalVisible(true)
    // handleBuyPackage(packageItem)
    handleAddToCart(packageItem)
    // setSelectedPackage(packageItem)
  }

  const handleTableChange = (page, pageSize) => {
    setPagination(prev => ({
      ...prev,
      current: page,
      pageSize: Number(pageSize), // ép kiểu rõ ràng
    }))
  }

  // const handleBuyPackage = async () => {
  //   if (!selectedPackage) {
  //     message.error("Vui lòng chọn gói cước để đăng ký")
  //     return
  //   }
  //   if (!phoneNumber) {
  //     message.error("Vui lòng nhập số điện thoại để đăng ký gói cước")
  //     return
  //   }
  //   if (!isLogin) {
  //     message.error("Vui lòng đăng nhập")
  //     // return navigate(ROUTER.DANG_NHAP, { state: { from: "order", record } })
  //     setModalLoginOpen(true)
  //     return
  //   }
  //   try {
  //     const response = await PackageService.buyPackageLeader({
  //       package_id: selectedPackage.ID,
  //       phone_number: phoneNumber,
  //       amount: selectedPackage.price,
  //     })

  //     // Nếu thành công
  //     message.success(response.message || "Đăng ký gói cước thành công!")
  //     setIsPhoneModalVisible(false)
  //     setSelectedPackage(null)
  //     fetchListPackage(keyword)
  //   } catch (error) {
  //     console.error("Error buying package:", error)

  //     if (error.response) {
  //       const { status, data } = error.response
  //       if (status === 401) {
  //         message.error(data?.message || "Đăng ký gói cước thất bại (401)")
  //       } else {
  //         message.error(data?.message || "Đăng ký gói cước thất bại.")
  //       }
  //     } else {
  //       message.error("Đã xảy ra lỗi không xác định. Vui lòng thử lại sau.")
  //     }
  //   }
  // }
  const handleSharePackage = packageItem => {
    const shareLink = `${window.location.origin}/share-package/${packageItem.ID}`
    navigator.clipboard
      .writeText(shareLink)
      .then(() => {
        message.success("Đã sao chép liên kết chia sẻ gói cước!")
      })
      .catch(err => {
        console.error("Failed to copy share link:", err)
        message.error("Không thể sao chép liên kết chia sẻ gói cước.")
      })
  }
  const handleBuyPackage = async () => {
    const commissionPercent =
      Number(localStorage.getItem(STORAGE.COMMISSION_PERCENT)) || 0
    console.log(cartItems, "cartItems in cart drawer")
    const result = cartItems?.map(item => {
      return {
        // ...item.package,
        sim_quantity: item.quantity,
        network_id: item.package.network_id || null,
        type_sim: item.package.type_sim || null,
        sim_type: item.package.sim_type || null,
        scope: item.package.scope || null,
        sim_unit_price: item.package.sim_unit_price || 0,
        package_id: item.package.package_id || null,
        supplier_id: item.package.supplier_id || null,
      }
    })
    console.log(result, "result")
    const totalAmount = cartItems.reduce((total, item) => {
      const price = parseFloat(item.package?.sim_unit_price)
      const quantity = item.quantity || 0
      return total + price * quantity
    }, 0)
    if (role === "LEADER" && isLogin) {
      setLoading(true)
      try {
        const payload = {
          total_amount: totalAmount,
          // total_discount: totalAmount - totalAmount * (commissionPercent / 100),
          sim: result,
        }
        console.log(payload, "payload")
        if (level !== "0" && isLogin) {
          await OrderB2BService.createOrderAgency(payload)
        } else {
          await OrderB2BService.createOrderB2B(payload)
        }
        message.success("Tạo đơn hàng thành công")
        setSelectedPackage(null)
        setBulkQuantity(1) // Reset số lượng về 1
        dispatch(clearCart()) // Xóa giỏ hàng sau khi mua thành công
        navigate(ROUTER.AGENT_SIM_PACKAGE_SERVICE)
      } catch (err) {
        // catch (error) {
        // console.error("Lỗi khi xử lý đơn hàng", error)
        // message.error(
        //   error.response?.data?.message || "Xử lý đơn hàng thất bại",
        // )
        if (err.response?.status === 400) {
          message.error(err?.response?.data?.message || "Lỗi không xác định")
        }
        const errorMessage =
          err?.response?.data?.message?.message ||
          err?.response?.data?.message ||
          "Lỗi không xác định từ máy chủ"
        if (err?.response?.data?.message?.amount_missing) {
          setArrearsMoney(err?.response?.data?.message?.amount_missing)
          setDepositVisible(true)
        }
        message.error(errorMessage)
      } finally {
        setLoading(false)
      }
    }
    // Đóng modal và reset các giá trị
    setIsPhoneModalVisible(false)
    // setSelectedPackage(null)
    // setBulkQuantity(1) // Reset số lượng về 1
    // dispatch(clearCart()) // Xóa giỏ hàng sau khi mua thành công
    onClose()
  }
  const handleRemoveItem = package_id => {
    dispatch(removeFromCart(package_id))
    message.success("Đã xóa gói cước khỏi giỏ hàng!")
  }

  const handleAddToCart = packageItem => {
    if (!packageItem || !packageItem.name) {
      message.error("Vui lòng chọn gói cước hợp lệ")
      return
    }

    dispatch(addToCart({ packageItem: packageItem, quantity: bulkQuantity }))
    message.success("Đã thêm gói vào giỏ hàng!")
  }

  const handleQuantityChange = (package_id, newQuantity) => {
    if (newQuantity <= 0) {
      message.error("Số lượng phải lớn hơn 0!")
      return
    }

    dispatch(updateCartItemQuantity({ package_id, newQuantity }))
    // message.success("Đã cập nhật số lượng!")
  }
  const handleCloseModal = () => {
    setDepositVisible(false)
    setArrearsMoney(0)
  }
  const handlePurchasePackage = async packageItem => {
    if (!isLogin) {
      message.error("Vui lòng đăng nhập để mua gói cước")
      setModalLoginOpen(true)
      return
    }
    const res = await OrderB2BService.pullBuyData({
      ProductCode: networkData,
      PackCode: packageItem.PackCode,
      BillingCode: keyword,
      Amount: packageItem.PackAmount,
    })
    if (res?.success?.original?.data?.Message === "Success") {
      message.success(
        res?.success?.original?.message || "Mua gói cước thành công",
      )
    } else {
      message.error(res?.success?.original?.message || "Mua gói cước thất bại")
    }
  }
  const renderPackages = () => {
    return data.map(packageItem => (
      <Col xs={24} md={12} xl={8} key={packageItem.ID}>
        <Card
          bordered
          hoverable
          style={{
            border: "1px solid #99CCFF",
            borderRadius: 16,
            marginBottom: 16,
            textAlign: "center",
            maxHeight: 300,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            padding: 0,
            transition: "box-shadow 0.3s ease, transform 0.3s ease",
          }}
          bodyStyle={{ padding: 24 }}
          // onClick={() => handleCardClick(packageItem)}
          onMouseEnter={e => {
            e.currentTarget.style.boxShadow = "0 8px 16px rgba(0,0,255,0.3)"
            e.currentTarget.style.transform = "translateY(-6px)"
          }}
          onMouseLeave={e => {
            e.currentTarget.style.boxShadow = ""
            e.currentTarget.style.transform = "translateY(0)"
          }}
        >
          {/* Header */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 16,
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                fontSize: 16,
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <FireFilled style={{ color: "#f5222d" }} />
              {networkData}
            </div>
            {/* <div style={{ color: "#999" }}>Chi tiết</div> */}
            <ShareAltOutlined
              style={{ fontSize: 18, color: "#1890ff", cursor: "pointer" }}
              onClick={e => {
                e.stopPropagation()
                message.success("Đã copy link chia sẻ gói cước")
                // handleSharePackage(packageItem)
              }}
              title="Chia sẻ gói cước"
            />
          </div>

          <div style={{ borderTop: "1px solid #eee", marginBottom: 16 }}></div>

          {/* DATA */}
          <div style={{ fontSize: 24, fontWeight: 700, marginBottom: 8 }}>
            {packageItem.PackName}
            {/* /
            {packageItem.PackTimeLimit} ngày */}
          </div>

          {/* Ghi chú */}
          <div
            style={{
              fontSize: 13,
              color: "#555",
              marginBottom: 24,
              minHeight: "40px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* <div>
              Nhà mạng: <strong>{packageItem?.network?.name}</strong>
            </div>
            <div>
              {serviceTypeMap[packageItem?.service_type] || "Unknown"} /
              {simType.find(opt => opt.key === packageItem?.sim_type)?.value ||
                "Unknown"}
            </div> */}
            {packageItem.PackData}
            {/*Miễn phí gọi nội mạng iTel & VinaPhone (áp dụng cuộc gọi dưới 10 phút, tối đa 1000 phút/tháng)*/}
          </div>
          {/* Giá và nút */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap", // Thêm dòng này
              gap: 8, // Và một chút khoảng cách
            }}
          >
            <div style={{ fontSize: 18, fontWeight: 600 }}>
              {new Intl.NumberFormat().format(packageItem.PackAmount)}/
              <span style={{ fontSize: 18 }}>
                {packageItem.PackTimeLimit} ngày
              </span>
            </div>
            <Button
              btnType="primary1"
              onClick={e => {
                e.stopPropagation()
                // setSelectedPackage(packageItem)
                handlePurchasePackage(packageItem)
              }}
            >
              Mua ngay
            </Button>
          </div>
        </Card>
      </Col>
    ))
  }

  return (
    <>
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: 30,
            marginBottom: 16,
            flexWrap: "wrap",
            gap: 8,
          }}
        >
          <h3
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              color: "#005F90",
              margin: 0,
            }}
          >
            MUA GÓI CƯỚC
          </h3>
          {/* {isLogin && (
            <Badge
              style={{ marginRight: 16 }}
              count={cartItems.length}
              offset={[10, 0]}
            >
              <Button
                btnType="primary1"
                icon={<ShoppingCartOutlined />}
                onClick={showDrawer}
              />
            </Badge>
          )} */}
        </div>
        {/* <div>
          <CheckPackage setFilter={setFilter} setKeyword={setKeyword} />
        </div> */}
        {/* <div style={{ margin: "10px 0", fontWeight: "bold", color: "#007BFF" }}>
          Tổng số gói cước: {pagination.total}
        </div> */}
        <InputSearchStyle style={{ marginBottom: 16, marginTop: 8 }}>
          <Input
            allowClear
            className="custom-input"
            maxLength={50}
            placeholder="Nhập số điện thoại"
            onChange={e => (inputSearchRef.current = e.target.value)}
            onPressEnter={onSearch}
            size="large"
          />
          <div className="custom-icon-search" onClick={onSearch}>
            <SvgIcon name="searchStatistic" />
          </div>
        </InputSearchStyle>
        {loading ? (
          <div style={{ textAlign: "center", padding: "40px 0" }}>
            <Spin size="large" />
          </div>
        ) : data.length === 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 200,
            }}
          >
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="Không có gói cước phù hợp"
            />
          </div>
        ) : (
          <Row gutter={[16, 16]}>{renderPackages()}</Row>
        )}
        {/* <div style={{ marginTop: 20, marginBottom: 20 }}>
          <Pagination
            style={{ display: "flex", justifyContent: "flex-end" }}
            current={pagination.current}
            pageSize={pagination.pageSize}
            total={pagination.total}
            onChange={handleTableChange}
            showSizeChanger
            pageSizeOptions={["6", "12", "18", "24"]}
          />
        </div> */}

        {/* Hiển thị modal chi tiết khi click vào gói cước */}
        {/* {isModalVisible && (
        <PackageDetailModal
          visible={isModalVisible}
          onClose={() => setIsModalVisible(false)}
          packageData={selectedPackage}
        />
      )} */}
      </div>
      {/* {drawerVisible && (
        <CartDrawer
          drawerVisible={drawerVisible}
          onClose={() => setDrawerVisible(false)}
          cartItems={cartItems}
          handleQuantityChange={handleQuantityChange}
          handleBuyPackage={handleBuyPackage}
          handleRemoveItem={handleRemoveItem}
        />
      )}
      {depositVisible && (
        <ModalDeposite
          depositVisible={depositVisible}
          depositAmount={arrearsMoney}
          handleCancel={handleCloseModal}
          onSuccess={() => {
            // clear
            setDepositVisible(false)
            setArrearsMoney(0)
            handleBuyPackage()
          }}
        />
      )}

      {modalLoginOpen && (
        <ModalAuth
          visible={modalLoginOpen}
          onClose={() => setModalLoginOpen(false)}
          // record={productRecord}
          selectedPackage={selectedPackage}
        />
      )} */}
    </>
  )
}
export default PackagePurchase
